import ArticleCard from "@/components/feature/ArticleCard";
import type { Article } from "@/mocks/articles";

interface LatestArticlesProps {
  articles: Article[];
}

export default function LatestArticles({ articles }: LatestArticlesProps) {
  return (
    <section className="py-10 md:py-14">
      <div className="w-full px-4 md:px-6">
        <h2 className="text-xl md:text-2xl font-bold text-foreground-950 mb-6 md:mb-8">最新文章</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {articles.map((article) => (
            <ArticleCard key={article.id} article={article} />
          ))}
        </div>
      </div>
    </section>
  );
}